import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, Alert } from 'reactstrap'
import { FaPlus } from 'react-icons/fa'
import { CREATE_MENU_ITEMS_QUERY } from '../../graphql.js'
import CreateMenuItem from './CreateMenuItem'
import { handleGraphQLErrors } from '../../utils.js'

export const CREATE_MENU_ITEMS = gql(CREATE_MENU_ITEMS_QUERY)

export default function CreateMenu() {
  console.log('CreateMenu rendered')

  const [items, setItems] = useState([])
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    let mounted = true
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: CREATE_MENU_ITEMS })
        if (data.createMenuItems) {
          const menuItems = []
          for (let item of data.createMenuItems) {
            menuItems.push(<CreateMenuItem key={item.id} item={item} />)
          }
          if (mounted) {
            setItems(menuItems)
          }
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    fetchItems()
    return (() => mounted = false)
  }, [])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (items.length > 0) {
    return (
      <UncontrolledDropdown nav inNavbar>
        <DropdownToggle nav caret data-cy="create-menu">
          <b><FaPlus style={{ verticalAlign: 'baseline'}} /> Create</b>
        </DropdownToggle>
        <DropdownMenu style={{ maxHeight: '500px', overflow: 'auto' }} >
          {items}
        </DropdownMenu>
      </UncontrolledDropdown>
    )
  }
  return ''
}
